import React from 'react';
import cx from 'classnames';
import styles from './OMButtonWithPreloader.scss';

const OMButtonWithPreloader = properties => (
  <button
    type={properties.type || 'submit'}
    className={cx('btn btn-primary', styles.default, styles[properties.className], properties.additionalClassName)}
    onClick={properties.onClick}
    disabled={properties.showPreloader}
    id={properties.id}
  >
    {
      (properties.showPreloader)
        ? (<span className="icon icon-om-spinner om-pulse" />)
        : properties.innerText
    }
  </button>);

export default OMButtonWithPreloader;
